import { render, staticRenderFns } from "./AdvisorsDashboardDetails.vue?vue&type=template&id=7d43e4ff&"
import script from "./AdvisorsDashboardDetails.vue?vue&type=script&lang=js&"
export * from "./AdvisorsDashboardDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports